import { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal } from "semantic-ui-react";
import { Boundary } from "../models/Boundary";
import { BoundaryTypeKey, mapBoundaryTypeKeyToBoundaryType } from "../models/BoundaryTypeKey";
import { AreaTypeKey } from "../models/globalTypes";
import { BoundaryType } from "../models/BoundaryType";

export interface FormData {
  typeKey: AreaTypeKey;
  comments: string;
}

interface Props {
  boundary?: Boundary;
  open: boolean;
  onClose: () => void;
  onSave: (updatedBoundary: Boundary) => void;
}

const EditBoundaryTypeOrCommentModal = ({ boundary, open, onClose, onSave }: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);

  useEffect(() => {
    if (open) {
      setFormData({
        typeKey: boundary?.type.key,
        comments: boundary?.comments,
      } as FormData);
    } else {
      setFormData({} as FormData);
    }
  }, [open, boundary]);

  const handleChange = (e: any, { name, value }: any) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = () => {
    const updatedBoundary = boundary ? { ...boundary } : ({} as Boundary);
    const selectedBoundaryType = mapBoundaryTypeKeyToBoundaryType(formData.typeKey);

    if (selectedBoundaryType) {
      updatedBoundary.type = { key: selectedBoundaryType.key, name: selectedBoundaryType.name } as BoundaryType;
    } else {
      updatedBoundary.type = undefined as any;
    }

    updatedBoundary.comments = formData.comments;

    onSave(updatedBoundary);
  };

  const handelClose = () => {
    onClose();
  };

  interface BoundaryTypeOption {
    key: number;
    text: string;
    value: AreaTypeKey;
  }

  var options = [
    {
      key: 1,
      text: BoundaryTypeKey.PermitBoundary.name,
      value: BoundaryTypeKey.PermitBoundary.key,
    } as BoundaryTypeOption,
    {
      key: 0,
      text: BoundaryTypeKey.AnnotationBoundary.name,
      value: BoundaryTypeKey.AnnotationBoundary.key,
    } as BoundaryTypeOption,
  ];

  return (
    <Modal open={open} size="mini">
      <Modal.Header>Edit boundary</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Dropdown}
                selection
                search
                name="typeKey"
                value={formData.typeKey}
                fluid
                label="Type"
                options={options}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.TextArea value={formData.comments} label="Comments" name="comments" onChange={handleChange} />
            </Form.Group>
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handelClose}>Cancel</Button>
        <Button onClick={handleSave} positive>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EditBoundaryTypeOrCommentModal;
